import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc4baa72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserListTableHeader = _resolveComponent("UserListTableHeader")!
  const _component_GuardianListTableRow = _resolveComponent("GuardianListTableRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: "guardian-list-table-container",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UserListTableHeader, {
        class: "table-header",
        "horizontal-margin": _ctx.horizontalMargin,
        "icon-cell-width": _ctx.iconCellWidth,
        "name-cell-width": _ctx.nameCellWidth,
        height: 40,
        "all-columns": _ctx.allColumns,
        "column-visibility": _ctx.flattenedColumnVisibility
      }, null, 8, ["horizontal-margin", "icon-cell-width", "name-cell-width", "all-columns", "column-visibility"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guardians, (guardian, idx) => {
        return (_openBlock(), _createBlock(_component_GuardianListTableRow, {
          key: guardian.userId,
          class: "table-row",
          "data-testid": `row-${guardian.userId}`,
          "horizontal-margin": _ctx.horizontalMargin,
          "icon-cell-width": _ctx.iconCellWidth,
          "name-cell-width": _ctx.nameCellWidth,
          "min-height": 32,
          "max-height": 80,
          "style-type": idx % 2,
          guardian: guardian,
          "column-visibility": _ctx.flattenedColumnVisibility,
          "user-id-to-edit-path": _ctx.userIdToEditPath,
          "link-enabled": _ctx.linkEnabled
        }, null, 8, ["data-testid", "horizontal-margin", "icon-cell-width", "name-cell-width", "style-type", "guardian", "column-visibility", "user-id-to-edit-path", "link-enabled"]))
      }), 128))
    ])
  ], 4))
}